import React from 'react'
import styled, { useTheme } from 'styled-components'

import { ResourceGroup } from 'dataHooks/useExploreResources'
import { Expand, Return } from './ColumnButtons'

import ResourcePreview from './ResourcePreview'
import device from 'utilities/device'

const ColumnContainer = styled.div<{ expand: boolean }>`
  flex-grow: 1;
  flex-basis: 0;
  flex-shrink: 1;
  background-color: ${({ theme }) => theme.primary};
  border-radius: 5px;
`
const Header = styled.header`
  position: sticky;
  color: ${({ theme }) => theme.background};
  text-align: center;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 115px;
`
const HeaderText = styled.h2`
  margin-bottom: 0.5rem;
  ${({ theme }) => theme.textStyleH4}
`
const ResourceCount = styled.div`
  ${({ theme }) => theme.textStyleMedParagraph}
  margin-bottom: 1rem;
`
const IconRow = styled.div`
  margin-top: 5px;
  display: grid;
  grid-template-areas: 'return icon expand';
  grid-template-columns: repeat(3, 1fr);
  @media ${device.mobileL} {
    grid-template-columns: 1fr;
  }
`

const Column: React.FC<{
  name: string
  expand: boolean
  resources: ResourceGroup
  setExpandColumn: (column: string | undefined) => void
}> = ({ name, resources, expand, setExpandColumn }) => {
  const theme: any = useTheme()
  return (
    <ColumnContainer expand={expand}>
      <Header>
        <IconRow>
          {!expand && <Expand onClick={() => setExpandColumn(name)} />}
          {/* <CMS.Icon
            noEmitError
            name={resources.fieldValue}
            color={theme.text}
            style={{ height: 30, gridArea: 'icon' }}
          /> */}
          {expand && <Return onClick={() => setExpandColumn(undefined)} />}
        </IconRow>
        <HeaderText>{name}</HeaderText>
        <ResourceCount>
          {resources.nodes.length} of {resources.totalCount} resources
        </ResourceCount>
      </Header>
      {resources &&
        resources.nodes
          //FIXME: not sure if "Title" is the right thing here
          .sort((a, b) => a.data.Title.localeCompare(b.data.Title))
          .map(({ data }) => (
            <ResourcePreview key={data.Title} {...{ data, expand }} />
          ))}
    </ColumnContainer>
  )
}

export default Column
